import { useCustomVariation } from "goi_common";
import { UrgentCallBanner } from "goi_common/src/design-system";

import { GOI_PHONE } from "@/constants/contact";
import { useParlorInquiryModal } from "@/hooks/useParlorInquiryModal";
import { toParlorDisplayName } from "@/utils/parlorDisplayName";

/**
 * now 콜 확대 첫 화면 임종 배너.
 * 광고 견적 LP(/place/[id]/quote)만 A/B 실험이고(B안만 배너), 장례식장 상세·무빈소는 실험 없이 바로 적용해 배포 전후로 비교한다(2026-10-14 영민).
 * 공통 견적(/quote)은 하게 되면 A/B 로 한다(2026-10-15 영민).
 * www 실험(platform `URGENT_CALL_BANNER_KEYS`)과 키를 따로 쓴다.
 */
export const URGENT_CALL_BANNER_KEY = 360;

/**
 * 광고 견적 LP 의 B안 배정 여부. 컨테이너에서 한 번만 불러 배너와 제목 옆 전화 버튼 숨김에 같이 쓴다.
 * 두 곳에서 각각 부르면 노출 이벤트가 두 번 찍힌다.
 */
export const useIsUrgentCallBannerShown = () =>
  useCustomVariation(URGENT_CALL_BANNER_KEY) === "B";

type UrgentCallBannerPage =
  | "parlor_ad_quote"
  | "prlr_fam_main"
  | "prlr_mubinso";

interface UrgentCallBannerSectionProps {
  page: UrgentCallBannerPage;
  parlor: { id: number; name: string };
  hideFloating?: boolean;
  onScrolledPastChange?: (isScrolledPast: boolean) => void;
  /**
   * 실험 없이 바로 적용한 페이지(상세·무빈소). 버튼에 대표번호를 보이고 문구를 바꿔 쓴다(2026-10-15 영민).
   * #360 은 실험 중이라 화면을 바꾸지 않도록 넘기지 않는다
   */
  isLive?: boolean;
}

export const UrgentCallBannerSection = ({
  page,
  parlor,
  hideFloating,
  onScrolledPastChange,
  isLive,
}: UrgentCallBannerSectionProps) => {
  const placeName = toParlorDisplayName(parlor.name);

  // 헤더 24시간 버튼과 같은 문의 유형 모달. 조문 문의만 장례식장 직통으로 거른다.
  // 모달 안 선택지 이벤트는 urgent_bnr path 로 쏴서 페이지 헤더 버튼 모달과 나눈다
  const { openParlorInquiryModal } = useParlorInquiryModal("urgent_bnr");

  return (
    <UrgentCallBanner
      // 별칭 병기를 그대로 두면 배너 한 줄이 모바일에서 여러 줄로 접힌다
      placeName={placeName}
      description={
        isLive ? (
          <>
            {placeName} 임종접수와 장례,
            <br />
            고이에서 전화 한 통으로 진행 가능해요
          </>
        ) : undefined
      }
      eventPath={page}
      eventProperties={{ parlor_id: parlor.id, parlor_name: parlor.name }}
      hideFloating={hideFloating}
      onScrolledPastChange={onScrolledPastChange}
      phoneNumber={isLive ? GOI_PHONE : undefined}
      onCall={() => void openParlorInquiryModal()}
    />
  );
};
